import React, { useEffect, Component } from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import { useLocation, Link } from 'react-router-dom';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function AngelikaSturnInfoPage() {
  const location = useLocation();
  useEffect(() => {
    // Prüfen, ob ein Hash in der URL vorhanden ist und zu diesem Element scrollen
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [location]);
  return <div className="min-h-screen bg-white" data-id="element-463">
      <Header data-id="element-464" />
      <main className="w-full pt-[152px]" data-id="element-465">
        {/* Hero Section mit Bild */}
        <div className="w-full flex justify-center" data-id="element-466">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-467">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5QCH3uivxYEX2Btw8W26kV/Header-Info-Angelika_Sturny.jpg" alt="Dr. Angelika Sturny Praxis" className="w-full h-full object-cover" data-id="element-468" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-469"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-470">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-471">
                <div className="max-w-lg text-left" data-id="element-472">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-473">
                    „Du bist mutiger, als du glaubst, stärker, als du scheinst,
                    und klüger, als du denkst."
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-474">– Christopher Robin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Hauptinhalt */}
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-475">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-476">
            Info
          </h1>
          {/* Terminbuchung Section */}
          <section id="terminbuchung" className="mb-16 scroll-mt-[180px]" data-id="element-477">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-478">
              Terminbuchung
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-479">
              <div className="mb-6 flex flex-col md:flex-row md:items-center gap-4" data-id="element-480">
                <span data-id="element-481">Sie kontaktieren mich über</span>
                <Link to="/angelika_sturny/termin-vereinbaren" data-id="element-482">
                  <button className="py-2 px-5 text-gray-700 rounded-md hover:font-semibold transition-colors" style={{
                  backgroundColor: '#cda8be'
                }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b88fa8'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#cda8be'} data-id="element-483">
                    Termin vereinbaren
                  </button>
                </Link>
                <span data-id="element-484">
                  oder schreiben eine{' '}
                  <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-485">
                    Mail
                  </a>
                </span>
              </div>
            </div>
            <div className="space-y-6" data-id="element-486">
              <div className="flex items-start" data-id="element-487">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-488"></div>
                <p className="text-lg text-gray-600" data-id="element-489">
                  Wir verabreden einen ungefähr 30-minütigen kostenfreien
                  Kennenlern-Termin, um Ziele und Erwartungen zu klären und
                  gegebenenfalls nächste Schritte zu besprechen.
                </p>
              </div>
              <div className="flex items-start" data-id="element-490">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-491"></div>
                <div className="text-lg text-gray-600" data-id="element-492">
                  <p className="mb-2" data-id="element-493">
                    Die Termine finden in meiner Praxis in Haar bei München oder
                    bei einem Spaziergang oder virtuelle über MS-Teams oder Zoom
                    statt – gerne sowohl in deutscher, als auch in englischer
                    Sprache.
                  </p>
                  <p data-id="element-494">Terminvereinbarungen sind auch am Wochenende möglich.</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-495">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-496"></div>
                <p className="text-lg text-gray-600" data-id="element-497">
                  Verlässliche Begleitung: Ich arbeite nicht mit festen
                  Programmen oder Paketlösungen. Stattdessen gestalte ich die
                  Zusammenarbeit individuell. Die Dauer richtet sich an Ihren
                  Bedürfnissen aus, so lange wie es sinnvoll, hilfreich und
                  wirksam ist.
                </p>
              </div>
            </div>
          </section>
          {/* Konditionen Section */}
          <section id="konditionen" className="mb-16 scroll-mt-[180px]" data-id="element-498">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-499">
              Konditionen
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-500">
              Hier finden Sie wichtige Informationen zu den Rahmenbedingungen
              meiner Praxis – von meinem Ansatz, über Konditionen und
              Terminabsagen bis hin zu Themen wie Selbstzahlung, privater
              Krankenversicherung und Schweigepflicht.
            </p>
            <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-501">
              <AccordionItem value="item-0" title="Mein Ansatz" data-id="element-502">
                <p className="text-lg text-gray-600" data-id="element-503">
                  Als systemische Familientherapeutin arbeite ich lösungs- und
                  ressourcenorientiert. Mein Ansatz betrachtet Herausforderungen
                  im Kontext von Beziehungen, Lebensgeschichten und Ressourcen.
                  Ziel ist es, neue Handlungsmöglichkeiten und Perspektiven zu
                  eröffnen. Weitere Informationen zu meiner therapeutischen
                  Haltung finden Sie{' '}
                  <a href="/angelika_sturny/psychotherapie" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-504">
                    hier
                  </a>
                  .
                </p>
              </AccordionItem>
              <AccordionItem value="item-1" title="Konditionen" data-id="element-505">
                <div className="overflow-x-auto mb-6" data-id="element-506">
                  <table className="w-full border-collapse" data-id="element-507">
                    <tbody data-id="element-508">
                      <tr className="border-b border-gray-200" data-id="element-509">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-510">
                          30-minütiges Kennenlern-Gespräch (oder Telefonat)
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-511">
                          Kostenfrei
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-512">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-513">
                          Einzeltherapie (60 Minuten)
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-514">
                          120 Euro (incl. MwSt)
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-515">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-516">
                          Paartherapie (90 Minuten)
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-517">
                          225 EUR (incl. MwSt)
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-518">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-519">
                          Systemische Familientherapie (90 Minuten)
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-520">
                          225 EUR (incl. MwSt)
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-521">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-522">
                          Einzelcoaching (60 Minuten)
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-523">
                          139 EUR (incl. MwSt)
                        </td>
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-524">
                        <td className="py-4 pr-4 text-lg text-gray-700" data-id="element-525">
                          Intensivberatung am Wochenende
                        </td>
                        <td className="py-4 text-lg text-gray-700 font-medium" data-id="element-526">
                          Nach Vereinbarung
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-lg text-gray-600" data-id="element-527">
                  Bitte beachten Sie: Ihren Termin können Sie bar im Anschluss
                  an den Termin oder via EC-Karte bezahlen.
                </p>
              </AccordionItem>
              <AccordionItem value="item-2" title="Terminabsagen" data-id="element-528">
                <p className="text-lg text-gray-600 mb-4" data-id="element-529">
                  Verbindlichkeit ist mir in der Zusammenarbeit sehr wichtig.
                  Termine halte ich für Sie reserviert und kann diese bei
                  kurzfristigen Absagen nicht mehr anderweitig vergeben. Deshalb
                  gelten folgende Stornoregelungen:
                </p>
                <div className="space-y-2" data-id="element-530">
                  <div className="flex items-start" data-id="element-531">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-532"></div>
                    <p className="text-gray-600" data-id="element-533">
                      Absagen bis zu 48 Stunden vor ihrem gebuchten Termin sind
                      kostenfrei.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-534">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-535"></div>
                    <p className="text-gray-600" data-id="element-536">
                      Für Absagen weniger als 48 Stunden vor dem Termin berechne
                      ich 60 % Stornokosten.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-537">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-538"></div>
                    <p className="text-gray-600" data-id="element-539">
                      Für Absagen weniger als 24h vor dem Termin berechne ich
                      100% Stornokosten.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-540">
                    <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-541"></div>
                    <p className="text-gray-600" data-id="element-542">
                      Bei kurzfristiger Absage aufgrund akuter Erkrankung kann
                      nach Vorlage eines ärztlichen Attests auf das
                      Ausfallhonorar verzichtet werden.
                    </p>
                  </div>
                </div>
              </AccordionItem>
              <AccordionItem value="item-3" title="Selbstzahler/Privatzahler" data-id="element-543">
                <p className="text-lg text-gray-600 mb-4" data-id="element-544">
                  Als Heilpraktikerin für Psychotherapie führe ich eine
                  Privatpraxis. Die Kosten für die Behandlung werden in der
                  Regel von Ihnen selbst getragen, da eine Abrechnung über die
                  gesetzliche Krankenkasse nicht möglich ist. Heilkundliche
                  Tätigkeit ist von der Umsatzsteuer gemäß § 4 Nr. 14 UStG
                  befreit. Aus diesem Grund erheben wir für Psychotherapie nach
                  dem Heilpraktikergesetz keine Umsatzsteuer und weisen diese
                  folglich auch nicht aus.
                </p>
                <p className="text-lg text-gray-600 mb-4" data-id="element-545">
                  Bei Selbstzahlenden entfällt die Beantragung der
                  Kostenerstattung sowie die Diagnosestellung für die
                  Krankenkasse. Aufgrund meiner Schweigepflicht gelangen keine
                  Informationen an Dritte wie etwa Krankenkassen,
                  Rentenversicherungen oder Berufsgenossenschaften. Dies kann
                  z.B. im Zusammenhang mit Risikozuschlägen oder
                  Gesundheitsprüfungen (z.B. Lebensversicherungen) von Vorteil
                  sein. Die Kosten für Psychotherapie können als
                  außergewöhnliche Belastung bei der Einkommensteuererklärung
                  geltend gemacht werden. Ebenso kann die Therapie kurzfristig
                  ohne lange Wartezeiten starten.
                </p>
                <p className="text-lg text-gray-600 mb-4" data-id="element-546">
                  Manchmal ist der Bedarf groß – aber die finanziellen
                  Möglichkeiten begrenzt. Deshalb halte ich zwei Therapie- bzw.
                  Beratungsplätze zu einem deutlich reduzierten Honorar bereit –
                  zum Beispiel für Studierende, Menschen in Übergangsphasen oder
                  bei finanziellen Engpässen.
                </p>
                <p className="text-lg text-gray-600" data-id="element-547">
                  Melden Sie sich gern – wir klären gemeinsam, ob ein Platz
                  verfügbar ist.
                </p>
              </AccordionItem>
              <AccordionItem value="item-4" title="Privat Versicherte" data-id="element-548">
                <p className="text-lg text-gray-600 mb-4" data-id="element-549">
                  Viele private Krankenversicherungen erstatten die Kosten voll
                  oder zum Teil. Die Voraussetzung für die Kostenerstattung, die
                  Anzahl der erstattungsfähigen Sitzungen und die Höhe der
                  erstatteten Sätze variiert jedoch stark zwischen den privaten
                  Krankenversicherungen und hängt ebenso von Ihrem individuellen
                  Tarif ab. Bitte klären Sie daher zuvor mit Ihrer
                  Krankenversicherung ab, welche psychotherapeutischen
                  Leistungen übernommen werden.
                </p>
                <p className="text-lg text-gray-600" data-id="element-550">
                  Die Kosten für Paartherapie/-beratung werden leider weder von
                  gesetzlichen noch privaten Krankenversicherungen erstattet.
                </p>
              </AccordionItem>
              <AccordionItem value="item-5" title="Schweigepflicht" data-id="element-551">
                <p className="text-lg text-gray-600" data-id="element-552">
                  Wir unterliegen der Schweigepflicht. Selbstverständlich werden
                  sämtliche Inhalte der Therapie sowie Ihre persönlichen Daten
                  diskret und streng vertraulich behandelt.
                </p>
              </AccordionItem>
            </Accordion.Root>
          </section>
          {/* Anfahrtsskizze Section */}
          <section id="anfahrt" className="mb-16 scroll-mt-[180px]" data-id="element-553">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-554">
              Anfahrtsskizze
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed" data-id="element-555">
              <p className="mb-4" data-id="element-556">
                Die Praxis befindet sich in Salmdorf/Haar. In der unmittelbaren
                Nähe befinden sich mehrere Haltestellen.
              </p>
              <div className="space-y-2 mt-4" data-id="element-557">
                <div className="bg-gray-50 p-5 rounded-lg" data-id="element-558">
                  <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-559">
                    Vom Münchner Hauptbahnhof
                  </h3>
                  <div className="space-y-2" data-id="element-560">
                    <div className="flex items-start" data-id="element-561">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-562"></div>
                      <p className="text-gray-600" data-id="element-563">
                        U Bahn (U 2: Richtung Messestadt Ost, Ausstieg
                        Messestadt Ost, ca. 15 min Fußweg)
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-564">
                      <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-565"></div>
                      <p className="text-gray-600" data-id="element-566">
                        S Bahn (S 4: Richtung Grafing oder Ebersberg) oder S 6
                        (Richtung Ebersberg), Ausstieg Gronsdorf und Umstieg in
                        den Bus nach Salmdorf/Kirche. 5 min Fußweg.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-5 rounded-lg" data-id="element-567">
                  <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-568">
                    Vom Münchner Flughafen
                  </h3>
                  <p data-id="element-569">
                    S Bahn (S 8 Richtung Herrsching, Umstieg Leuchtenbergring, S
                    6 Richtung Ebersberg, Ausstieg Haltestelle Gronsdorf).
                    Umstieg in den Bus nach Salmdorf/Kirche. Ca. 5 min Fußweg.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-lg" data-id="element-570">
                  <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-571">
                    Anfahrt mit dem Auto
                  </h3>
                  <p className="text-gray-600" data-id="element-572">
                    Die Praxis befindet sich im Osten von München in
                    Haar/Salmdorf. Es sind ausreichend Parkplätze in der
                    Seidlhofstraße (mit Parkscheibe) vorhanden.
                  </p>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-573">
                <p className="text-gray-600" data-id="element-574">
                  Appointments are also possible in English. Please contact me
                  via{' '}
                  <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-575">
                    email
                  </a>{' '}
                  for sessions in English!
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-576" />
    </div>;
}
// Accordion Item Component
const AccordionItem = ({
  children,
  value,
  title
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-577">
      <Accordion.Header data-id="element-578">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-579">
          <span className="text-lg font-medium text-gray-700" data-id="element-580">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#cda8be] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-581" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-582">
        <div className="p-4 bg-white" data-id="element-583">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};